import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
// EventPage is no longer needed

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* The HomePage component will now handle all routes starting with '/' */}
        <Route index element={<HomePage />} />
        {/* This path allows HomePage to read the :slug parameter */}
        <Route path="events/:slug" element={<HomePage />} />
      </Route>
    </Routes>
  );
}

export default App;
